import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

export interface BusinessTypeCategory {
    id: number,
    name: string,
    code: string,
    selectable: boolean,
    parentId: number
}

@Injectable()
export abstract class BusinessTypeCategoriesService {

    private readonly URL = `/api/${this.context}/dictionary/bussines-type-categories`;

    constructor(private http: HttpClient, private context) {
    }

    getBusinessTypeCategories(): Observable<BusinessTypeCategory[]> {
        return this.http.get<BusinessTypeCategory[]>(this.URL);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/business-type-categories.service.ts